'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Field = _ref.Field,
      validationMap = _ref.validationMap,
      composeValidators = _ref.composeValidators;

  var FormFieldsWrapper = function (_React$Component) {
    _inherits(FormFieldsWrapper, _React$Component);

    function FormFieldsWrapper() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, FormFieldsWrapper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = FormFieldsWrapper.__proto__ || Object.getPrototypeOf(FormFieldsWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.getPosition = function (index, length) {
        var position = 'default';

        if (index === 0 && length === 3) {
          position = 'lonely';
        } else if (index === length - 3) {
          position = 'end';
        } else if (index === 0) {
          position = 'start';
        }

        return position;
      }, _this.renderField = function (_ref3) {
        var field = _ref3.field,
            input = _ref3.input,
            meta = _ref3.meta,
            rest = _objectWithoutProperties(_ref3, ['field', 'input', 'meta']);

        return _react2['default'].cloneElement(field, _extends({
          input: input,
          meta: meta
        }, rest));
      }, _this.composeValidators = function (inputType, required) {
        var inputTypeValidator = validationMap[inputType] || undefined;

        if (required && inputTypeValidator) {
          return composeValidators(validationMap['required'], inputTypeValidator);
        }

        if (required && !inputTypeValidator) {
          return composeValidators(validationMap['required']);
        }

        return inputTypeValidator;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FormFieldsWrapper, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            handleSubmit = _props.handleSubmit,
            children = _props.children,
            subscription = _props.subscription;
        return _react2['default'].createElement('form', {
          onSubmit: handleSubmit,
          noValidate: true
        }, children.map(function (child, index) {
          if (!child.props.inputType) return child;

          var position = _this2.getPosition(index, children.length);

          return _react2['default'].createElement(Field, {
            key: child.props.fieldName,
            name: child.props.fieldName,
            position: position,
            subscription: subscription,
            render: _this2.renderField,
            validate: _this2.composeValidators(child.props.inputType, child.props.required),
            field: child,
            type: child.props.inputType
          });
        }));
      }
    }]);

    return FormFieldsWrapper;
  }(_react2['default'].Component);

  FormFieldsWrapper.displayName = identifier;
  FormFieldsWrapper.propTypes = {
    children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node]),
    handleSubmit: _propTypes2['default'].func,
    subscription: _propTypes2['default'].func
  };
  return FormFieldsWrapper;
};

exports['default'] = factory;